<template>
  <v-menu v-model="showCustomiseModal" offset-y :close-on-content-click="false">
    <v-flex
      slot="activator"
      shrink
      class="filter_item separator"
      style="cursor: pointer; border-top-left-radius: 8px; background: #f0f6fa"
    >
      <v-layout>
        <v-icon color="#0277bd" :size="15"> settings </v-icon>
        <span class="heading">Customize</span>
      </v-layout>
    </v-flex>
    <v-card v-if="showCustomiseModal" class="card">
      <v-layout column>
        <v-layout row justify-space-between>
          <span class="card-title">Customize table display</span>
          <v-icon @click="showCustomiseModal = false">close</v-icon>
        </v-layout>
        <span class="card-subtitle"
          >Select up to 10 columns to display in the Attendee list table.</span
        >
        <draggable v-model="fields" @change="onListChanged">
          <transition-group type="transition" :name="'flip-list'">
            <div v-for="item in splittedList" :key="item.field">
              <v-layout
                v-if="item.type !== 'splitter'"
                align-center
                :class="{
                  field: item.type === 'active',
                  'field-inactive': item.type === 'inactive',
                }"
              >
                <v-icon
                  :size="19"
                  :color="item.type === 'active' ? 'primary' : '#979797'"
                  class="drag-indicator"
                  >drag_indicator</v-icon
                >
                <span :style="item.type === 'inactive' && 'color: #979797'">{{ item.field }}</span>
              </v-layout>
              <div v-if="item.type === 'splitter'">
                <v-divider class="divider" />
                <v-layout column align-center>
                  <span class="divider-text">Drag above the line to display</span>
                </v-layout>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="apply-button-container">
          <main-button class="apply-button" text="Apply" @click="apply" />
        </div>
      </v-layout>
    </v-card>
  </v-menu>
</template>

<script>
import draggable from 'vuedraggable'
import { difference } from 'lodash'

import { setVisibleFields } from '../../../utils'

export default {
  name: 'customise-modal',
  components: {
    draggable,
  },
  props: {
    visibleFields: Array,
    allFields: Array,
    eventId: String,
  },
  data() {
    return {
      showCustomiseModal: false,
      fields: this.fieldsWithSplitter(),
    }
  },
  computed: {
    splittedList() {
      const splittedFields = []

      const splitterIndex = this.fields.indexOf('splitter-divider')

      this.fields.forEach((field, index) => {
        if (index < splitterIndex) {
          splittedFields.push({
            type: 'active',
            field,
          })
        } else if (index === splitterIndex) {
          splittedFields.push({
            type: 'splitter',
            field,
          })
        } else {
          splittedFields.push({
            type: 'inactive',
            field,
          })
        }
      })

      return splittedFields
    },
  },
  methods: {
    onListChanged() {
      const splitterIndex = this.fields.indexOf('splitter-divider')

      if (splitterIndex > 10) {
        this.fields.splice(splitterIndex, 1)
        this.fields.splice(10, 0, 'splitter-divider')
      }
    },
    fieldsWithSplitter() {
      const invisibleFields = difference(this.allFields, this.visibleFields.slice(0, 10))

      return [...this.visibleFields, 'splitter-divider', ...invisibleFields]
    },
    apply() {
      const newFields = this.splittedList.filter(f => f.type === 'active').map(f => f.field)
      this.$emit('fieldsChanged', newFields)
      setVisibleFields(newFields, this.eventId)
      this.showCustomiseModal = false
    },
  },
}
</script>

<style scoped>
@media (min-width: 800px) {
  .separator {
    border-right: 2px solid white;
  }
}
.drag-indicator {
  cursor: pointer;
  margin-right: 8px;
  margin-left: 8px;
}
.filter_item {
  padding: 14px 15px;
}
.heading {
  color: #0277bd;
  font-size: 16px;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  line-height: 1.25;
  margin-left: 6px;
  margin-right: 6px;
}
.filter_item {
  padding: 14px 15px;
  text-transform: uppercase;
}
.filter_item:hover {
  background-color: rgba(2, 119, 189, 0.2);
}
.card {
  margin-top: 8px;
  width: 430px;
  border-radius: 8px;
  padding: 16px 20px;
  max-height: 540px;
  overflow: auto;
}
@media (max-width: 800px) {
  .card {
    width: 100%;
  }
}
.field {
  max-width: 392px;
  height: 40px;
  background-color: #f5f5f5;
  margin-bottom: 8px;
  border-radius: 8px;
  cursor: pointer;
}
.field-inactive {
  background-color: #f5f5f5;
  max-width: 392px;
  height: 40px;
  margin-bottom: 8px;
  border-radius: 8px;
  cursor: pointer;
}
.card-title {
  color: #0277bd;
  font-size: 20px;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 5px;
}
.card-subtitle {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
}
.divider-text {
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  font-size: 12px;
  color: #0277bd;
  line-height: 12px;
  text-transform: uppercase;
  margin-bottom: 8px;
  cursor: default;
}
.apply-button {
  max-width: 80px;
  margin-top: 20px !important;
}
.apply-button-container {
  display: flex !important;
  justify-content: flex-end !important;
}
.divider {
  margin-bottom: 8px;
  margin-top: 4px;
}
.extend-height > div {
  height: 56px;
}
.tile:hover {
  cursor: pointer;
}
</style>
